// Copyright (c) 2026 Chain Capital Technologies Ltd. All rights reserved.
// See LICENSE file in the project root for full license information.

import { resolveBrand, type ProductCoDescriptor } from '../brand.js';
import '../styles/product-subtitle.css';

/** Operator + product label rendered above the primary heading on
 * accept-offer and vault-detail. A second product co is now server data,
 * not a copy edit: the offer/terms responses may carry a `productco`
 * descriptor (COB-394). `productTypeLabel` maps it to the "Type" copy —
 * the legacy string when absent (inert), "BTC yield by <name>" otherwise.
 * Single source of truth: it delegates to `resolveBrand` so this subtitle
 * and the offer-card title can't drift. */
export function productTypeLabel(productco?: ProductCoDescriptor): string {
  return resolveBrand(productco).productLabel;
}

/** Payout formula identifier used by every offer the user-app surfaces
 * today. Mirrors `LOSS_FORMULA_BEAR_CALL_SPREAD_V1` on the Rust side
 * (`services/user-app/src/contract_builder.rs`). The accept page has no
 * contract yet, so it falls back to this constant; vault-detail passes
 * `contract.loss_formula` instead so the displayed value is the one
 * actually committed at vault creation. */
export const DEFAULT_PAYOUT_FORMULA = 'bear_call_spread_v1';

export function ProductSubtitle({
  payoutFormula,
  productco,
}: {
  payoutFormula?: string;
  productco?: ProductCoDescriptor;
}) {
  return (
    <dl class="product-subtitle">
      <div class="product-subtitle-row">
        <dt>Type</dt>
        <dd>{productTypeLabel(productco)}</dd>
      </div>
      <div class="product-subtitle-row">
        <dt>Payout</dt>
        <dd>{payoutFormula ?? DEFAULT_PAYOUT_FORMULA}</dd>
      </div>
    </dl>
  );
}
